import type { FC } from "react";

import { noop } from "lodash";

import { MetricCard } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { percentageSignFilter } from "app/filters/ngFilters";
import type { ICardData } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/sentiment-overview/types";

interface ISentimentCardProps extends ICardData {
    totalMentions: number;
    isLoading?: boolean;
    hasData?: boolean;
}

export const SentimentCard: FC<ISentimentCardProps> = ({
    title,
    tooltip,
    text,
    promptsCount,
    totalMentions,
    isLoading,
    hasData,
}) => {
    const mentionsPercent = totalMentions ? promptsCount / totalMentions : 0;
    const value = hasData && !isNaN(mentionsPercent) ? percentageSignFilter()(mentionsPercent) : null;

    return (
        <MetricCard
            title={title}
            tooltip={tooltip}
            value={value}
            secondaryValue={
                hasData && text ? (
                    <Text
                        fontVariant="listItem3"
                        color={colorsPalettes.carbon[400]}
                    >
                        {text}
                    </Text>
                ) : null
            }
            isLoading={isLoading}
            onCtaClick={noop}
        />
    );
};
